// import React from "react";
// import { Handle } from "@xyflow/react";

// /**
//  * Unified Handle component with proper interactivity and styling.
//  */
// export function FlowHandle({ style, ...props }) {
//   return (
//     <Handle
//       {...props}
//       isConnectable={true}
//       style={{
//         pointerEvents: "all",
//         width: 10,
//         height: 10,
//         borderRadius: "50%",
//         border: "2px solid #6b7280", // gray-500
//         background: "white",
//         zIndex: 10,
//         ...style, // allow overrides from caller
//       }}
//       className="react-flow__handle"
//     />
//   );
// }

// src/components/commons/flowHandle.jsx
// src/components/commons/flowHandle.jsx
import React from 'react';
import { Handle } from '@xyflow/react';

/**
 * Unified Handle component compatible with React Flow edge connections.
 * Styled similar to Tailwind version but Bootstrap-friendly.
 */
export function FlowHandle({ style, ...props }) {
  return (
    <Handle
      {...props}
      className="react-flow__handle"
      style={{
        width: 12,
        height: 12,
        borderRadius: '50%',
        border: '2px solid #6b7280', // gray-500
        background: '#ffffff',
        zIndex: 100000,
        // Important: DO NOT override pointerEvents or boxSizing.
        // These are managed by React Flow to enable proper connections.
        ...style
      }}
    />
  );
}
